import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export function BaseAcctUnit() {
    return (
        <>
            {/* <div>内部核算单位</div> */}
            <PageHeader />
            <DataBox />
        </>
    )
}